import React, { Component } from "react";

import "./style.scss";
import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

import {Button} from '@learningblocks/exp-components/lib/Button';


export class ProtocolTable extends Component {

  constructor(props) {
    super(props);

    this.state = {
      updated: false,
      tableData: this.props.tableData,
      dropDownOptions:[
        "Extracted DNA",
        "Gene X homozygous normal Control DNA",
        "Gene X homozygous mutated Control DNA",
        "Water",
        "Prokaryotic Control DNA"
      ]
    }
  }

  numsOnly = text => {
    text = text.replace(/[^0-9.]/g, "")

    return text;
  };

  handleInputChange = (e, row, index) => {
    if (this.numsOnly(e.target.value) !== e.target.value) {
      e.target.setCustomValidity("Please input an integer");
      e.target.reportValidity();
    } else {
      e.target.setCustomValidity("");
    }

    let tableData = this.state.tableData;
    tableData.data[row][index] = this.numsOnly(e.target.value)

    this.setState({
      tableData: tableData,
      updated: true
    })

  };

  handleSelectChange = (e, row, index) => {

    let tableData = this.state.tableData;
    tableData.data[row][index] = e.target.value

    this.setState({
      tableData: tableData,
      updated: true
    })

  };

  handleSubmit = (e) => {
    //e.preventDefault();
    this.props.setProtocolTableData({
      tableData: this.state.tableData
    });
    this.setState({
      updated: false
    })
    // this.props.showModal({
    //   display: false
    // });
  };

  getContent = (content, headings) => {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: "32px"
      }}>
        <div style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: colors.navy1
        }}>
          {headings.map((heading, index) => {
            return (
              <div
                style={{
                  borderTopWidth: 1,
                  borderLeftWidth: 1,
                  borderBottomWidth: "1px",
                  borderColor: colors.navy4,
                  borderStyle: "solid",
                  flexBasis: 1,
                  flexGrow: 1,
                  flexShrink: 1,
                  borderRightWidth: index === headings.length - 1 ? "1px" : 0,
                }}
              >
                <p style={{
                  color: "white",
                  fontSize: "16px",
                  padding: 8,
                  margin: 0,
                  whiteSpace: "pre-wrap"
                }}>{heading}</p>
              </div>
            );
          })}
        </div>
        {content.map((row, rowIndex)=>{
          return(
            <div style={{
              display: "flex",
              flexDirection: "row",
              backgroundColor: (rowIndex === 0)?"white":null
            }}>
            {row.map((item, itemIndex) => {
              return (
                <div
                  style={{
                    borderTopWidth: "1px",
                    borderLeftWidth: "1px",
                    borderBottomWidth: "1px",
                    borderColor: colors.navy4,
                    borderStyle: "solid",
                    marginBottom: -1,
                    flexBasis: 1,
                    flexGrow: 1,
                    flexShrink: 1,
                    backgroundColor: itemIndex === 0 ? colors.navy1 : null,
                    borderRightWidth: itemIndex === row.length - 1 ? "1px" : 0
                  }}
                >
                  {(rowIndex === 0 || itemIndex === 0)?(
                    <p style={{
                      // color: "black",
                      fontSize: "16px",
                      padding: 8,
                      margin: 0,
                      color: itemIndex === 0 ? "white" : null
                    }}>{item}</p>
                  )
                  :
                  (itemIndex === 2)?(
                    <select onChange={e => this.handleSelectChange(e, rowIndex, itemIndex)} id={"ProtocolTable_"+rowIndex+"_"+itemIndex}>
                      <option value="" disabled selected>Select DNA Template</option>
                      {this.state.dropDownOptions.map((option)=>(
                        <option value={option} selected={item === option}>{option}</option>
                      ))}
                    </select>
                  ):(
                    <div className="input-group">
                      <input onChange={e => this.handleInputChange(e, rowIndex, itemIndex)} type="text" placeholder="Enter μl" id={"ProtocolTable_"+rowIndex+"_"+itemIndex} value={item}/>
                      <div className="input-group-append">
                        <span class="input-group-text">μl</span>
                      </div>
                    </div>
                  )
                  }
                </div>
              );
            })}
            </div>
          )
        })}
      </div>
    );
  };

  render() {
    return (
      <div className="ProtocolTable notebook">
        <div className="notebook-content">
          <div className="notebook-content__body">
            <div className="title">
              <h2>Protocol Table</h2>
            </div>
            {this.getContent(this.state.tableData.data, this.state.tableData.headings)}
            <div style={{textAlign: "right", marginTop: "16px"}}>
              <Button disabled={!this.state.updated} className='submitProtocolTable' onClick={(e)=>this.handleSubmit(e)}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
